module.exports = __webpack_public_path__ + "static/media/wolfgang_simma.05c13370.jpg";